export const PATIENT_NAME_MAX_CHAR_LENGTH = 18;
